<template>
    <span>{{ timeLeft }}</span>
</template>

<script>
//INSPIRATION: https://codepen.io/samanthaming/pen/WgrYZr

export default {
    name: 'Countdown',
    props: {
        end: {
            type: Number,
        },
    },
    data: () => {
        return {
            intervalTimer: null,
            timeLeft: '00:00',
            secondsLeft: 0,
        };
    },
    watch: {
        end: {
            handler(val){
                this.secondsLeft = Math.round((val - Date.now()) / 1000);
                if (this.secondsLeft < 0) {
                    this.secondsLeft = 0;
                }
                this.timer();
            },
            immediate: true
        }
    },
    methods: {
        zeroPadded(num) {
            // 4 --> 04
            return num < 10 ? `0${num}` : num;
        },
        timer(seconds) {
            this.displayTimeLeft(seconds);
            this.countdown();
        },
        countdown() {
            this.intervalTimer = setInterval(() => {
                this.secondsLeft = Math.round((this.end - Date.now()) / 1000);

                if (this.secondsLeft < 0) {
                    clearInterval(this.intervalTimer);
                    this.$emit('time-up');
                    return;
                }
                this.displayTimeLeft(this.secondsLeft);
            }, 1000);
        },
        displayTimeLeft() {
            const minutes = Math.floor((this.secondsLeft % 3600) / 60);
            const seconds = this.secondsLeft % 60;

            this.timeLeft = `${this.zeroPadded(minutes)}:${this.zeroPadded(seconds)}`;
        },
    }
};
</script>
